import React from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';

type Props = {
    showModal: boolean;
    handleClose: any;
    handleLogout: any;
};

const IdleTimeOutModal: React.FC<Props> = React.memo(({ showModal, handleClose, handleLogout }) => {
    return (
        <Box
            id="idletimeout-modal-container"
            sx={{
                height: 300,
                flexGrow: 1,
                minWidth: 300,
                transform: 'translateZ(0)',
                '@media all and (-ms-high-contrast: none)': {
                    display: 'none',
                },
            }}
        >
            <Modal
                id="idletimeout-modal"
                open={showModal}
                onClose={handleClose}
                sx={(theme) => ({
                    display: 'flex',
                    padding: theme.spacing(1),
                    alignItems: 'center',
                    justifyContent: 'center',
                })}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                <Box
                    id="idletimeout-modal-paper-div"
                    sx={(theme) => ({
                        width: 400,
                        backgroundColor: theme.palette.background.paper,
                        border: '2px solid #000',
                        boxShadow: theme.shadows[5],
                        padding: theme.spacing(2, 4, 3),
                    })}
                >
                    <Typography id="idletimeout-modal-heading" variant="h4">
                        Idle Timeout
                    </Typography>
                    <Typography id="idletimeout-modal-body">
                        Looks like the you have been idle for quiet sometime, do you want to
                        continue using the app ?
                    </Typography>
                    <div id="idletimeout-modal-btn-container" style={{ marginTop: '10px' }}>
                        <Button
                            id="idletimeout-modal-close-btn"
                            onClick={handleClose}
                            className="btn btn-success"
                            type="button"
                            style={{ marginRight: '10px' }}
                        >
                            close
                        </Button>
                        <Button
                            id="idletimeout-modal-logout-btn"
                            onClick={handleLogout}
                            className="btn btn-danger"
                            type="button"
                        >
                            Logout
                        </Button>
                    </div>
                </Box>
            </Modal>
        </Box>
    );
});

export default IdleTimeOutModal;
